import downTimeImage from '@assets/images/downtime/downtime.svg';
import type { DowntimeSchedule } from '@generated/graphql';
import type { SxProps } from '@mui/material';
import { Box, Typography } from 'hephaestus/web';
import { useLocalization } from '../../../hooks/useLocalization';

const Downtime = ({
  downtime,
  testId = 'downtime',
}: {
  downtime: DowntimeSchedule;
  supportUrl?: string;
  testId?: string;
}) => {
  const { translateBackendString } = useLocalization();
  return (
    <Box data-testid={testId} sx={containerSx as any}>
      <Box
        data-testid={`${testId}-content-container`}
        sx={{
          display: 'flex',
          gap: '20px',
          flexDirection: 'column',
          width: '40%',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography
          data-testid={`${testId}-title`}
          variant='displayMediumVariant'
          sx={{ textAlign: 'center' }}
        >
          {translateBackendString(downtime.translatedTitle)}
        </Typography>
        {downtime.translatedDescription && (
          <Typography
            data-testid={`${testId}-description`}
            variant='bodyLarge'
            sx={{ textAlign: 'center' }}
            color='textSecondary'
          >
            {translateBackendString(downtime.translatedDescription)}
          </Typography>
        )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          maxHeight: { xs: '70%', sm: '55%', md: '40%' },
          maxWidth: { xs: '70%', sm: '55%', md: '40%' },
        }}
      >
        <img
          src={downTimeImage}
          alt='downtime-img'
          width='100%'
          height='100%'
        />
      </Box>
    </Box>
  );
};

export default Downtime;

const containerSx: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-evenly',
  alignItems: 'center',
  gap: '30px',
  height: { xs: '100%', sm: 'calc(100vh - 110px)' }, // Note: 110px is the collective height for margin-top and top and bottom paddings.
  mt: { xs: 2, md: 0 },
};
